import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {PasswordResetService} from '../services/password-reset.service';
import {Store} from '@ngrx/store';
import {PasswordResetState} from '../reducers';
import * as AuthActions from '../actions/user.actions';
import {catchError, exhaustMap, filter, map, mergeMap} from 'rxjs/operators';
import {RequestReset, Reset} from '../models/user';
import {of} from 'rxjs';
import {GlobalMessage, GlobalMessageType} from '../../core/models/global-message';
import * as GlobalMessageActions from '../../core/actions/global-message.actions';

@Injectable()
export class PasswordResetEffects {
    constructor(private actions$: Actions,
                private passwordResetService: PasswordResetService,
                private store: Store<PasswordResetState>) {
    }

    requestReset$ = createEffect(() => this.actions$.pipe(
        ofType(AuthActions.requestReset),
        map(action => action),
        exhaustMap((resetData: RequestReset) => {
            return this.passwordResetService
                .requestReset(resetData)
                .pipe(
                    map(response => AuthActions.requestResetSuccess()),
                    catchError(error => of(AuthActions.requestResetFailure({authError: error})))
                );
        })
    ));

    requestResetFailure$ = createEffect(() => this.actions$
        .pipe(
            ofType(AuthActions.requestResetFailure),
            filter(action => action.authError.isGlobalMessage),
            mergeMap((action) => {
                    const message: GlobalMessage = {
                        id: 'auth-login-failure',
                        type: GlobalMessageType.ERROR,
                        message:
                            `The reset process couldn't be performed: ${action.authError.errorMessage} [${action.authError.errorCodeFormatted}]`
                    };
                    return of(GlobalMessageActions.addMessage({globalMessage: message}));
                }
            )
        ));

    reset$ = createEffect(() => this.actions$.pipe(
        ofType(AuthActions.reset),
        map(action => action),
        exhaustMap((resetData: Reset) => {
            return this.passwordResetService
                .reset(resetData)
                .pipe(
                    map(response => AuthActions.resetSuccess()),
                    catchError(error => of(AuthActions.resetFailure({authError: error})))
                );
        })
    ));

    resetFailure$ = createEffect(() => this.actions$
        .pipe(
            ofType(AuthActions.resetFailure),
            filter(action => action.authError.isGlobalMessage),
            mergeMap((action) => {
                    const message: GlobalMessage = {
                        id: 'auth-login-failure',
                        type: GlobalMessageType.ERROR,
                        message:
                            `The reset process couldn't be performed: ${action.authError.errorMessage} [${action.authError.errorCodeFormatted}]`
                    };
                    return of(GlobalMessageActions.addMessage({globalMessage: message}));
                }
            )
        ));
}
